/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import FormikInput from 'src/components/formik/FormikInput';
import Table from 'src/components/table/Table';
import PropTypes from 'prop-types';

function SlabForm({
    slab,
    onRemove,
}) {
    return (
        <div className="card">
            <div className="card-body">
                <h5 className="card-title">Slab Details</h5>
                <div className="form-row">
                    <div className="form-group">
                        <label>Target</label>
                        <FormikInput
                            name="tempSlab.target"
                            type="number"
                            className="form-control"
                        />
                    </div>
                </div>

                <div className="form-row">

                    <div className="form-group ml-1">
                        <label>Reward</label>
                        <FormikInput
                            name="tempSlab.reward"
                            type="number"
                            className="form-control"
                        />
                    </div>

                </div>

                <div className="form-row">
                    <div className="form-group ml-1">
                        <label>Is Reward in Percentage?</label>
                        <FormikInput
                            name="tempSlab.isRewardPercentage"
                            type="checkbox"
                            className="ml-3"
                        />
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group ml-1">
                        <label>
                            Achievement Reward
                            {' '}
                            <small>Default is none</small>
                        </label>
                        <FormikInput
                            name="tempSlab.achievementReward"
                            type="number"
                            className="form-control"
                        />
                    </div>
                </div>
                <div className="form-row">

                    <div className="form-group ml-1">
                        <label>Is Achievement Reward in Percentage?</label>
                        <FormikInput
                            name="tempSlab.isAchievementRewardPercentage"
                            type="checkbox"
                            className="ml-3"
                        />
                    </div>
                </div>

                <Table
                    hasRemove
                    removeClick={onRemove}
                    recordsPerPage={slab.length}
                    searchData={{
                        data: slab,
                        count: slab.length,
                        currentPage: 0,
                    }}
                    columns={{
                        target: {
                            display: 'Target',
                        },
                        reward: {
                            display: 'Reward',
                        },
                        isRewardPercentage: {
                            display: 'Is Reward Percentage',
                        },
                        achievementReward: {
                            display: 'Achievement Reward',
                        },
                        isAchievementRewardPercentage: {
                            display: 'Is Achievement Reward Percentage',
                        },
                    }}
                />
            </div>
        </div>
    );
}

SlabForm.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    slab: PropTypes.array,
    onRemove: PropTypes.func.isRequired,
};

SlabForm.defaultProps = {
    slab: [],
};

export default SlabForm;
